@if(displayType === 'PLAIN' || displayType === 'INTENNSE_VIEW') {
    <div #gestureArea>
        {{ clock().value | date: clock().timePipe }}
    </div>
} @else {
    <div class="container" [style.height.px]="rowHeight">
        <div #gestureArea class="counter ion-text-center">
            <div class="lable-official" [ngStyle]="{'font-size': rowHeight / 5 + 'px'}">
                {{ clock().name === 'DEFAULT' ? clock().type : clock().name | translate }}
            </div>

            <div class="clock-official" [ngStyle]="{'font-size': rowHeight * 3 / 5 + 'px' }">
                {{ clock().value | date: clock().timePipe }}
            </div>
        </div>
        @if (showButtons) {
            <div class="controller-btn">
                @if (clock().isPaused) {
                    <ion-button class="btn" (click)="startClock()" color="tertiary">
                        <ion-icon slot="icon-only" name="play"></ion-icon>
                    </ion-button>
                } @else if (!clock().isPaused && clock().value > 0) {
                    <ion-button class="btn" (click)="pauseClock()" color="tertiary">
                        <ion-icon slot="icon-only" name="pause"></ion-icon>
                    </ion-button>
                }
            </div>

            <div class="controller-btn">
                <ion-button class="btn" (click)="clearClock()" color="warning">
                    <ion-icon slot="icon-only" name="refresh"></ion-icon>
                </ion-button>
            </div>
        }
    </div>
}


<app-time-picker #timePicker [value]="clock().value" (updateValue)="updateClock($event)"></app-time-picker>
